import React from "react";

const PMSmartDataFormatter = ({ data, maxLength, handleReadMore }) => {
  if (!data) return null;

  const getCleanRawData = (htmlString) => {
    if (!htmlString) return "";
    let clean = htmlString;
    clean = clean.replace(/<br\s*\/?>/gi, "\n");
    clean = clean.replace(/&nbsp;/gi, " ");
    clean = clean.replace(/<\/?[^>]+(>|$)/g, ""); 
    return clean;
  };

  const rawData = getCleanRawData(data);

  const renderValue = (val) => {
    if (!val) return "";
    const trimmed = val.trim();

    if (trimmed.includes("{") && trimmed.includes("}")) {
      try {
        const regex = /['"]([^'"]+)['"]\s*:\s*(?:['"]([^'"]*)['"]|([^,}]+))/g;
        
        const items = [];
        let match;
        while ((match = regex.exec(trimmed)) !== null) {
          items.push({
            key: match[1], 
            value: match[2] !== undefined ? match[2] : (match[3] ? match[3].trim() : "")
          });
        }

        if (items.length > 0) {
          return (
            <div className="mt-0">
              {items.map((item, idx) => (
                <div key={idx} className="d-block">
                  <span className="font-weight-bold">{item.key}: </span>
                  <span>{item.value}</span>
                </div>
              ))}
            </div>
          );
        }
      } catch (e) {
      }
    }
    return <span>{trimmed}</span>;
  };

  const typeMatch = rawData.match(/Type:\s*([\s\S]*?)(?=Old Value:|$)/i);
  const oldMatch = rawData.match(/Old Value:\s*([\s\S]*?)(?=New Value:|$)/i);
  const newMatch = rawData.match(/New Value:\s*([\s\S]*)/i);

  const typeVal = typeMatch ? typeMatch[1].trim() : "";
  const oldVal = oldMatch ? oldMatch[1].trim() : "";
  const newVal = newMatch ? newMatch[1].trim() : "";

  if (typeVal || oldVal || newVal) {
    return (
      <div className="text-left" style={{ fontSize: '13px' }}>
        {typeVal && (
          <div className="mb-2">
            <span className="font-weight-bold">Type: </span>
            <span>{typeVal}</span>
          </div>
        )}

        <div className="mb-2">
            <span className="font-weight-bold">Old Value: </span>
            <div className="pl-2">
                {renderValue(oldVal || "None")}
            </div>
        </div>

        <div className="mb-1">
            <span className="font-weight-bold">New Value: </span>
            <div className="pl-2">
                {renderValue(newVal || "None")}
            </div>
        </div>
      </div>
    );
  }

  if (maxLength && rawData.length > maxLength) {
    return (
      <div>
        <span style={{ whiteSpace: 'pre-wrap' }}>
          {rawData.substring(0, maxLength)}...
        </span>

        <span 
          className="text-primary ml-2" 
          style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '13px' }} 
          onClick={() => {
             if (handleReadMore) handleReadMore(data);
          }}
        >
          Read More
        </span>
      </div>
    );
  }

  return <span style={{ whiteSpace: 'pre-wrap' }}>{rawData}</span>;
};

export default PMSmartDataFormatter;